import { render } from "./Sidebar.vue?vue&type=template&id=083ea0e9&ts=true"
import script from "./Sidebar.vue?vue&type=script&lang=ts"
export * from "./Sidebar.vue?vue&type=script&lang=ts"

import exportComponent from "/home/cipherx/.thelounge-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/Sidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "083ea0e9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('083ea0e9', __exports__)) {
    api.reload('083ea0e9', __exports__)
  }
  
  module.hot.accept("./Sidebar.vue?vue&type=template&id=083ea0e9&ts=true", () => {
    api.rerender('083ea0e9', render)
  })

}


export default __exports__